export default "__VITE_ASSET__374096c0__"